import React from 'react';
import { Star } from 'lucide-react';

const Reviews = () => {
  const reviews = [
    {
      name: 'Sarah Martinez',
      location: 'Southwest Lubbock',
      initials: 'SM',
      rating: 5,
      text: 'These guys are amazing! My second-story windows hadn\'t been cleaned in years because I couldn\'t reach them. They made them look brand new. Fast, friendly, and affordable. Will definitely use them again.'
    },
    {
      name: 'David Thompson',
      location: 'Northwest Lubbock',
      initials: 'DT',
      rating: 5,
      text: 'Raider Washing did an incredible job on our home. The windows are crystal clear and they even cleaned the tracks and frames. Love supporting local Texas Tech students doing great work!'
    },
    {
      name: 'Jessica Chen',
      location: 'Central Lubbock',
      initials: 'JC',
      rating: 5,
      text: 'Quick response, showed up on time, and the results speak for themselves. My windows have never looked this good. Highly recommend to anyone in the Lubbock area!'
    }
  ];

  return (
    <section id="reviews" className="py-24 bg-gradient-to-b from-zinc-950 to-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-['Bebas_Neue'] text-6xl md:text-7xl text-white mb-4">
            WHAT OUR <span className="text-[#CC0000]">CUSTOMERS SAY</span>
          </h2>
          <p className="text-gray-400 text-lg">
            Real reviews from satisfied customers across Lubbock
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-zinc-900 to-black border border-zinc-800 rounded-lg p-8 hover:border-[#CC0000] transition-all duration-300 hover:shadow-lg hover:shadow-red-900/20"
            >
              {/* Star Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="fill-[#CC0000] text-[#CC0000]" size={20} />
                ))}
              </div>

              {/* Review Text */}
              <p className="text-gray-300 leading-relaxed mb-6 italic">
                "{review.text}"
              </p>

              {/* Customer Info */}
              <div className="flex items-center gap-4 pt-4 border-t border-zinc-800">
                <div className="w-12 h-12 rounded-full bg-[#CC0000] flex items-center justify-center">
                  <span className="text-white font-bold text-lg">
                    {review.initials}
                  </span>
                </div>
                <div>
                  <div className="text-white font-semibold">{review.name}</div>
                  <div className="text-gray-500 text-sm">{review.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
